import * as sharedTypes from 'src/actions/shared/sharedTypes';
import createCollectionResource from 'src/actions/shared/createResource';
import { toastError, toastSuccess } from 'src/actions/toast';
import { User } from 'src/models/Users/User';

const usersResource = createCollectionResource<User>({
  name: 'users',
  endpoint: 'v1/orgs/:orgId/users',
});

const updateActivationToken: sharedTypes.AppThunk =
  ({ userId }: { userId: string }) =>
  async (dispatch, getState, { gateways }) => {
    try {
      await gateways.users.updateActivationToken({ userId });

      dispatch(toastSuccess('Invitation sent.'));
    } catch (err) {
      dispatch(toastError('Invite failed to send. Come back and try again later.'));
    }
  };

usersResource.effects.updateActivationToken = updateActivationToken;

export default usersResource;
